import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=eafb9644&scoped=true"
import script from "./layout-footer.vue?vue&type=script&lang=ts"
export * from "./layout-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafb9644",
  null
  
)

export default component.exports